<template>
    <div class="suppo-ord-page ve-list-page">
        <!-- 顶部操作工具栏：仅保留核心业务操作按钮，表头保留原生字段过滤与排序 -->
        <div class="suppo-ord-toolbar">
            <div class="toolbar-left-group">
                <el-button size="small" @click="nextGen" type="danger" icon="iconfont icon-xiashuangjiantou">
                    <span>{{ $LANG('1047', '下推送货单') }}</span>
                </el-button>
                <el-button size="small" @click="downFile" type="primary" icon="iconfont icon-xiazai">
                    <span>{{ $LANG('0231', '下载合同执行条款') }}</span>
                </el-button>
            </div>
            <div class="toolbar-right-group">
                <el-button size="small" @click="dropSel('fldset')" icon="iconfont icon-ziyuan">
                    <span>{{ $LANG('0683', '字段设置') }}</span>
                </el-button>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="tabData"
            :columnHiddenOption="columnHiddenOption"
            :footer-data="[]"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :event-custom-option="eventCustomOption"
            :max-height="tabHeight"
            :virtual-scroll-option="virtualScrollOption"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :cellSelectionOption="{enable: false}"
            v-loading="v_loading"
            :element-loading-text="$LANG('1959', '加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            id="suppo_ord_table"
            ref="tabref">
        </ve-table>
        </div>
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input>
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <el-dialog v-if="setWin" :visible.sync="setWin" width="480px" append-to-body top="6vh"
            class="wb-field-settings-overlay" custom-class="wb-field-settings-dialog"
            :close-on-click-modal="false" :title="$LANG('0683', '字段设置')">
            <div slot="title" class="wb-field-settings-title">
                <i class="el-icon-setting" aria-hidden="true"></i>
                <div>
                    <h2>{{ $LANG('0683', '字段设置') }}</h2>
                    <p>{{ $LANG('', '拖拽调整顺序，勾选设置显示与冻结') }}</p>
                </div>
            </div>
            <easy-win class="wb-field-settings-editor" :colArr="fldArr" @child-exit="setWin=false" @child-sure="setOk" />
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div>
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >
                    <div class="one-toolbar">
                    <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>
                                <el-checkbox size="medium" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox>
                                <el-select size="medium" :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-select size="medium" :disabled="saveFlag" v-else-if="item.FLDNO==='ACTNO'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in cashArr " :key="index" :label="item.ACCNM" :value="item.ACCNM"></el-option>
                                </el-select>
                                <el-select size="medium" filterable v-else-if="item.key==='SUPNO'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <el-row v-for="item in supArr " :key="item.IDNO">
                                        <el-col :span="6">
                                            <el-option  :label="item.IDNO" :value="item.IDSEQ"></el-option>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-option  :label="item.SUPTYNM" :value="item.IDSEQ"></el-option>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-option  :label="item.SUPNM" :value="item.IDSEQ"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
                                <el-select size="medium" filterable v-else-if="item.key==='STAFFNM'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <el-row v-for="item in empArr " :key="item.IDNO">
                                        <el-col :span="6">
                                            <el-option  :label="item.IDNO" :value="item.EMPNM"></el-option>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-option  :label="item.DEPTNM" :value="item.EMPNM"></el-option>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-option  :label="item.EMPNM" :value="item.EMPNM"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-toolbar">
                    <span class="spanRow"> {{ $LANG('1005', '采购明细') }}</span>
                </div>
                <el-table  :data="dtlData"
                    border
                    size="small"
                    style="margin-top:-8px"
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    ref="refdtl"
                    show-summary
                    :summary-method="getSummary"
                    :height="400"
                    highlight-current-row
                    @row-click="perClick" >
                    <el-table-column :label="$LANG('0310', '序号')" width="55" type="index"></el-table-column>
                    <el-table-column  v-for="(item ,index) in perCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"
                        :sortable="item.key!=='RN' &&item.edcss!=='checkbox' &&item.sortable=='N'"
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <el-checkbox v-if="item.edcss=='checkbox'" disabled  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>
                            <span v-else v-text="scope.row[item.key]"></span>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="one-toolbar"  >
                    <div class="spanRow" style="display:flex;  ">{{ $LANG('1026', '附件明细') }}</div>
                </div>
                <div style="display:flex;margin-left:10px;" >
                    <span v-for="(item,index) in imgData" :key="index">
                        <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH">
                            <div   slot="error" style="color:red;font-weight:600">文件名：{{item['FILENM']}}</div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                            <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </span>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 审批意见 -->
        <el-dialog v-dialogDrag :visible.sync="cfmWin" width="600px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1220', '回复日期内容') }}</span>
            </div>
            <div style="font-size:11px;line-heigth:30px">{{ $LANG('1349', '预计交货日期') }}：</div>
            <el-date-picker type="date"  :clearable="false" v-model="v_dttm" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
            <div style="font-size:11px;line-heigth:30px">{{ $LANG('0535', '交货备注') }}：</div>
            <el-input  type="textarea" :rows="7"  v-model="v_rmk"></el-input>
            <span slot="footer"  >
                <el-button type="info" @click="cfmWin=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                <el-button @click="cfmSure" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('1638', '确定') }} </el-button>
            </span>

            <div style="line-height:30px;border-bottom:2px solid #389;margin-top:5px;background:white"><i class="iconfont icon-xinxi" style="margin-right:4px"></i>{{ $LANG('0235', '上传已盖单的采购合同(可以是图片或PDF格式）') }}</div>
            <div style="display:flex" >
                <Upload
                    ref="upload"
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-success="successImgFile"
                    :on-progress="handleProgress"
                    :with-credentials="true"
                    :format="['jpg','jpeg','png','gif','pdf']"
                    :max-size="4096"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    v-if="!FILEPATH "
                    type="drag"
                    :action="uploadUrl"
                    style="display: inline-block;width:200px; ">
                    <div   style="padding: 1px 0;width:200px;height:190px;">
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image>
                        <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                    </div>
                </Upload>
                <div style="display:flex;margin-left:30px;min-height:200px;flex-wrap:wrap"  >
                    <div v-if="FILEPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">
                        <div v-if="FILEPATH &&FILEPATH.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH]" style="width:200px;height:150px;" :src="FILEPATH">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">{{ $LANG('1025', '附件名称') }}：{{FILEPATH}}</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link  :underline="false" @click="imgDel(0)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                            <el-link v-if="FILEPATH.lastIndexOf('pdf')>-1" :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> PDF{{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div>
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 下推窗口 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="nextWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:30px; font-size:14px;padding-left:5px;">{{ $LANG('1047', '下推送货单') }}</span>
            </div>
            <div style="height:40px;line-height:30px;border-bottom:2px solid #389;padding-bottom:4px; ">
                <el-checkbox :label="$LANG('0263', '全选')" v-model="v_selAll" @change="selRec" true-label="Y" false-label="N"></el-checkbox>
                 {{ $LANG('0298', '字段') }}
                <el-select v-model="selparam3"  :placeholder="$LANG('1675', '请选择列名')" filterable  size="small" style="width:130px; margin-left:4px">
                    <span v-for="item in stkCol" :key='item.key' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam3" @keyup.enter.native="nextSet" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper3" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="nextSet" ></el-button>
                </el-input>
                <el-checkbox true-label="Y" false-label="N" v-model="isSame" style="line-height:30px;margin-left:15px;margin-right:4px; "><span style="font-size:11px">{{ $LANG('1172', '与采购数相同') }}</span></el-checkbox>
                <el-button type="danger" @click="alloCate" size="small" icon="iconfont icon-shipeiqi" style="width:110px;margin-left:10px;height:35px;margin-top:2px;line-height:15px;color:white">{{ $LANG('0523', '下推记录') }}</el-button>
            </div>
            <div style="height:86vh;overflow-y:auto;  ">
                <el-table  :data="nextData.filter(item=>item.ISNEXT=='N')"
                    border
                    size="small"
                    ref="refnext"
                    v-loading="t_loading"
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    class="custom-table-border"
                    cell-class-name="clearPadding"
                    :cell-style="{padding:'2px'}"
                    :height="400"
                    highlight-current-row >
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="65"></el-table-column>
                    <el-table-column  v-for="(item ) in stkCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"

                        show-overflow-tooltip
                        :align="item.align"
                        :sortable="item.edcss!=='checkbox'&&item.key!=='RN'"
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox @change="chkChg(scope.row)" v-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>
                            <el-input-number v-else-if="item.key=='SHPQTY'" :id="scope.$index+scope.column.property"
                                    size="mini" style="width:100%" controls-position="right"
                                     v-model="scope.row[item.key]"></el-input-number>
                            <el-input v-else-if="item.key=='SENDRMK'" :id="scope.$index+scope.column.property"
                                    size="mini" style="width:100%" controls-position="right"
                                     v-model="scope.row[item.key]"></el-input>
                            <span v-else  >{{scope.row[item.key]}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table  :data="sendData"
                    border
                    size="small"
                    ref="refsend"
                    class="custom-table-border"
                    :cell-style="{padding:'2px'}"
                    :height="maxHeight"
                    highlight-current-row >
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="65"></el-table-column>
                    <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"
                        :sortable="item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>
                            <div v-else  >{{scope.row[item.key]}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="nextDel(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button  type="info" @click="nextWin=false" size="mini"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button style="margin-left:30px" type="primary" @click="genSend" size="mini"  icon="iconfont icon-chenggong1"> {{ $LANG('1119', '生成送货单') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>
        </el-dialog>
    </div>
</template>
<script>
import OrderPage from '@/views/srmmgt/suppo_ord.vue'
import EasyWin from '@/views/datamgt/easy_field.vue'
import { getTabColOrData } from '@/api/user'

// The workbench owns the mat_datalib headers/settings; the imported order page
// remains the source of every permission-sensitive business operation.
function createOrderOptions(component) {
    const source = component.options || component
    const components = { ...source.components }
    delete components.VeColumnConfigDialog
    const page = {
        ...source,
        components,
        mixins: [],
        data() {
            const data = source.data.call(this)
            data.setWin = false
            data.fldArr = []
            data.loadWin = false
            data.v_sort = 'asc'
            data.stfg_ = 'ALL'
            data.v_inputrow = { ...data.v_inputrow, STFG: 'Y', ISCHK: '' }
            data.columnWidthResizeOption = {
                enable: true,
                minWidth: 20,
                sizeChange: ({ column, columnWidth }) => {
                    const targetCol = this.vueCol.find(item=>item.key==column.key)
                    if (targetCol) targetCol.width = columnWidth
                }
            }
            return data
        },

        methods: {
            ...source.methods,
            enterDown(event) {
                if (event.keyCode==13) this.qryTabData()
            },
            inputChg(e,column) {
                this.$set(this.v_inputrow, column, e.target.value)
            },
            rowShow() {
                this.v_row = {}
                this.v_inputrow = {}
                return source.methods.rowShow.call(this)
            },
            dropSel(val) {
                if (val =='fldset'){  //字段设置显示--隐藏
                this.fldArr =[]
                getTabColOrData(this.v_url ,'V_USER_FLDSET','idseq','397191-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                    let v_setArr =res.result
                    //预处理：将 v_setArr中所有的FLDNO提取出来，转为大写，存入 Set
                    const existFldnos =new Set()
                    v_setArr.forEach(item=>existFldnos.add(item.FLDNO.toUpperCase()))
                    // 遍历 vueCol, 检查是否存在
                    this.vueCol.forEach(item =>{
                        const keyUpper = (item.key||'').toUpperCase()
                        if (!existFldnos.has(keyUpper)){
                            let v_obj ={'IDSEQ':'397191-1',LSTSEQ:'',COLWIDTH:item.width,CORPID:this.v_corpid,USERNO:this.v_username,FLDNO:item.key,FLDNM:item.title, 'VISFLAG':'Y'}
                            v_setArr.push(v_obj)
                            // 同时也添加到 Set 中，防止 vueCol 中有重复的 key 导致重复添加
                            existFldnos.add(keyUpper)
                        }
                    })
                    //构建Map,源数组 : key ---> COLWIDTH
                    const widthMap =new Map(this.vueCol.map(item=>[item.key,item.width]))
                    //遍历目标数组并更新
                    let updateColumns =v_setArr.map(col =>{
                        if (widthMap.has(col.FLDNO)){
                            return {...col ,COLWIDTH:widthMap.get(col.FLDNO)}
                        }
                        return col
                    })
                    this.fldArr =[...updateColumns]
                })
                this.setWin =true
                }
            },
            getSetList(){
            getTabColOrData(this.v_url, 'V_USER_FLDSET','idseq','397191-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_data =res.result
                if (v_data && v_data.length>0) { // 有用户个性化记录
                    let v_arr=[]
                    this.columnHiddenOption['defaultHiddenColumnKeys'] =[]
                    // 1、隐藏 ，2、列宽 3、排序
                    v_data.forEach(item=>{
                        if (item['VISFLAG'] =='N') {
                            this.columnHiddenOption['defaultHiddenColumnKeys'].push(item['FLDNO'])
                        }else{
                            v_arr.push(item['FLDNO'])
                        }
                    })
                    this.$refs["tabref"].showColumnsByKeys(v_arr)
                    this.$refs["tabref"].hideColumnsByKeys(this.columnHiddenOption['defaultHiddenColumnKeys'])
                    //1.1 构建 Map : key -> {width,sortby,isfix} ,使用 Map 提高查找效率
                    const configMap =new Map() //建立索引映射
                    v_data.forEach(item =>{
                        configMap.set(item['FLDNO'],{COLWIDTH:item.COLWIDTH,SORTBY:item.SORTBY,ISFIX:item['ISFIX']})
                    })
                    //console.log(JSON.stringify(configMap))
                    //1.2 遍历 vueCol ,同步 width 宽度 与 冻结 fixed
                    this.vueCol.forEach(col =>{
                        const  targetCol= configMap.get(col['key'])
                        if (targetCol){
                            col.width =targetCol['COLWIDTH']
                            col.fixed =targetCol['ISFIX']=='Y'?"left":targetCol['ISFIX']=='R'?"right":false
                        }
                    })
                    //1.3 根据个性化的 SORTBY排序 来更新
                    this.vueCol.sort((a,b)=>{
                        const targetA =configMap.get(a['key'])
                        const targetB =configMap.get(b['key'])
                        const sortA = (targetA  && targetA.SORTBY!==undefined)?targetA.SORTBY:9999
                        const sortB = (targetB  && targetB.SORTBY!==undefined)?targetB.SORTBY:9999
                        return sortA - sortB
                    })
                }
            })
        },
            setOk(v_obj){
            v_obj.forEach((item,index)=>item['SORTBY']=index+1)
            this.loadWin =true
            this.$axios({
                method: 'post',
                url: 'xuper_auth/batDtlSave2' ,
                data: {p_json:JSON.stringify(v_obj), p_table:'USER_FLDSET',p_idseq:'397191-1', p_action:'S' },
            }).then(res=>{
                if (res.code=='200') {
                    this.getSetList()
                    this.setWin =false
                    this.loadWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadWin =false
                }
            })
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            }
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
            qryTabData() {
                return this.getOrdList()
            },
            getOrdList() {
                // The native mounted hook still loads permissions and related data.
                // Its legacy date argument is superseded by the current header filters.
                let v_cond ='', v_oper='', v_edcss='', invalidNumber=false
                if (this.selparam && this.txtparam !== '' && this.txtparam !== null && this.txtparam !== undefined) {
                    this.tabArr.some(item=>{
                        if (item['key']==this.selparam) v_edcss=item['edcss']
                    })
                    let value=String(this.txtparam).trim().replace(/'/g,"''")
                    if (!['like','=','!=','>','<','>=','<='].includes(this.oper) || (v_edcss=='number' && !/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value))) {
                        this.promptWin=true
                        this.prompt=this.$LANG('', '请输入有效的数字和比较运算符')
                        return
                    }
                    let field=this.selparam
                    if (v_edcss=='date' || v_edcss=='time') field='substr('+field+',1,10)'
                    if (this.oper==='like') {
                        v_cond=v_cond+' and upper('+field+') like upper(\'%'+value+'%\')'
                    }else if (v_edcss=='number') {
                        v_cond=v_cond+' and '+field+this.oper+value
                    }else {
                        v_cond=v_cond+' and '+field+this.oper+'\''+value+'\''
                    }
                }
                // Native confirmation uses this.v_row as its document draft.
                // Query the synchronized input snapshot without replacing that draft.
                let v_row={...this.v_inputrow}
                Object.keys(v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                    if (v_row[item] !== '' && v_row[item] !== null && v_row[item] !== undefined) {
                        v_edcss=''
                        this.tabArr.some(it=>{
                            if (it['key']==item) v_edcss=it['edcss']
                        })
                        v_oper=(item === 'STFG' || item === 'ISCHK') ? '=' : (v_row['#OPER'+item] || (v_edcss=='number' || v_edcss=='date' || v_edcss=='time' ? '=' : 'like'))
                        let value=String(v_row[item]).trim().replace(/'/g,"''")
                        if (!['like','=','!=','>','<','>=','<='].includes(v_oper) || (v_edcss=='number' && !/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value))) {
                            invalidNumber=true
                            return
                        }
                        let field=item
                        if (v_edcss=='date' || v_edcss=='time') field='substr('+field+',1,10)'
                        if (v_oper=='like') {
                            v_cond=v_cond+' and upper('+field+') like upper(\'%'+value+'%\')'
                        }else if (v_edcss=='number') {
                            v_cond=v_cond+' and '+field+v_oper+value
                        }else {
                            v_cond=v_cond+' and '+field+v_oper+'\''+value+'\''
                        }
                    }
                })
                if (invalidNumber) {
                    this.promptWin=true
                    this.prompt=this.$LANG('', '请输入有效的数字和比较运算符')
                    return
                }
                this.current=1
                const user=String(this.v_username).replace(/'/g, "''")
                // This supplier entry always keeps organization and supplier scope.
                v_cond += ` and paysrc!='433336' and supno in (select empidseq from v_sys_user where userno='${user}') and stfg='Y' and ordstfg!='END'`
                const orderKey=this.initCol.some(item => item.key === this.selparam) ? this.selparam : 'ORDDTTM'
                const requestId=++this.queryRequestId
                this.v_loading=true
                return this.$axios({
                    method:'post',
                    url:'xuper_auth/getBaseData',
                    data:{ p_key:'POTY', p_value:'PRD', p_key2:'corpid', p_value2:this.v_corpid, p_cond:v_cond+' order by '+orderKey+' desc', p_table:'V_po_ord' }
                }).then(res=>{
                    if (requestId !== this.queryRequestId) return
                    if (res.code==='200') {
                        this.allData=res.result
                        this.initPage()
                        this.$nextTick(()=>{
                            const table=this.$refs.tabref
                            if (table && typeof table.doLayout==='function') table.doLayout()
                        })
                    } else {
                        this.promptWin=true
                        this.prompt=res.result
                    }
                }).catch(error=>{
                    if (requestId !== this.queryRequestId) return
                    this.promptWin=true
                    this.prompt=error.message || this.$LANG('1641', '查询失败')
                }).finally(()=>{
                    if (requestId === this.queryRequestId) this.v_loading=false
                })
            },
            getTabField(){
                let vm=this
                this.tabArr=[]
                this.vueCol=[]
                this.perCol=[]
                this.stkCol=[]
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397191','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                    vm.initCol=res.result
                    res.result.forEach(item=>{
                        const title=vm.$translate.getColTitle(item, vm.$store.state.lang)
                        vm.tabArr.push({
                            title,
                            key:item.key,
                            align:item.align,
                            width:item.width,
                            thide:item.THIDE,
                            fhide:item.FHIDE,
                            edcss:item.EDCSS,
                            disabled:item.DISABLED,
                            dotnum:item.DOTNUM,
                            sortable:item.SORTABLE,
                        })
                        if (item.THIDE !== 'N' && item.key !== 'SEL') return
                        vm.vueCol.push({
                            field:item.key,
                            key:item.key,
                            title,
                            type:item.EDCSS=='checkbox'?'check':item.EDCSS,
                            align:item.align,
                            width:Number(item.width),
                            sortable:false,
                            ellipsis:{showTitle:true},
                            renderHeaderCell: ({column}, h) => {
                                if (item.key === 'SEL') return <div class="suppo-ord-select-header"><div class="suppo-ord-select-header__title">{column.title}</div><el-checkbox size="mini" true-label="Y" false-label="N" v-model={this.v_select} on-change={() => this.selChg()}></el-checkbox></div>
                                const label = <el-link underline={false} on-click={()=>{this.sortChange(column)}} style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>
                                if (item.EDCSS === 'date' || item.EDCSS === 'time') return <div><div style="margin-top:3px;display:flex;white-space:nowrap">{label}</div><input type="date" value={this.v_inputrow[item.key]} on-keydown={(event)=>this.enterDown(event)} on-input={(e)=>this.inputChg(e,item.key)} style="padding:0;margin-top:1px;width:100%;height:28px" /></div>
                                if (item.key === 'STFG') {
                                    return (
                                        <div>
                                            <div style="margin-top:3px;display:flex;white-space:nowrap">{label}</div>
                                            <select
                                                value={this.v_inputrow['STFG'] || 'Y'}
                                                on-change={(e) => { this.$set(this.v_inputrow, 'STFG', e.target.value); this.qryTabData() }}
                                                style="width:100%;background:white;height:28px;margin-top:1px;border:1px solid #dcdfe6;border-radius:2px;font-size:12px;padding:0 4px;"
                                            >
                                                <option value="">全部</option>
                                                <option value="Y" >{this.$LANG('1976', '已审核')}</option>
                                                <option value="N">{this.$LANG('2005', '未审核')}</option>
                                                <option value="P">{this.$LANG('1961', '审核中')}</option>
                                                <option value="K">{this.$LANG('1970', '已发起')}</option>
                                            </select>
                                        </div>
                                    )
                                }
                                if (item.key === 'ISCHK') {
                                    return (
                                        <div>
                                            <div style="margin-top:3px;display:flex;white-space:nowrap">{label}</div>
                                            <select
                                                value={this.v_inputrow['ISCHK'] || ''}
                                                on-change={(e) => { this.$set(this.v_inputrow, 'ISCHK', e.target.value); this.qryTabData() }}
                                                style="width:100%;background:white;height:28px;margin-top:1px;border:1px solid #dcdfe6;border-radius:2px;font-size:12px;padding:0 4px;"
                                            >
                                                <option value="">全部</option>
                                                <option value="Y">{this.$LANG('2047', '是')}</option>
                                                <option value="N">{this.$LANG('2044', '否')}</option>
                                            </select>
                                        </div>
                                    )
                                }
                                if (item.EDCSS === 'number') return <div><div style="margin-top:3px;display:flex;white-space:nowrap">{label}</div><div style="display:flex"><select value={this.v_inputrow[`#OPER${item.key}`] || '='} on-change={(e)=>this.inputChg(e,`#OPER${item.key}`)} style="width:60px;background:white;height:28px;margin-top:1px"><option value="=">=</option><option value=">">&gt;</option><option value="<">&lt;</option><option value="!=">!=</option></select><input value={this.v_inputrow[item.key]} on-keydown={(event)=>this.enterDown(event)} on-input={(e)=>this.inputChg(e,item.key)} style="padding:0;margin-top:1px;width:100%;height:28px" /></div></div>
                                return <div><div style="margin-top:3px;display:flex;white-space:nowrap">{label}</div><input disabled={item.EDCSS==='image'} value={this.v_inputrow[item.key]} on-keydown={(event)=>this.enterDown(event)} on-input={(e)=>this.inputChg(e,item.key)} style="padding:0;margin-top:1px;width:100%;height:28px" /></div>
                            },
                            renderBodyCell: ({row}, h) => {
                                const value = row[item.key]
                                if (item.key === 'IDNO') return <el-link underline={false} on-click={() => this.repShow(row)}><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px">{value}</div></el-link>
                                if (item.key === 'STFG') {
                                    if (value === 'Y') return <el-tag size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag>
                                    if (value === 'N') return <el-tag size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag>
                                    if (value === 'P') return <el-tag size="mini" type="danger" effect="dark">{this.$LANG('1961', '审核中')}</el-tag>
                                    if (value === 'K') return <el-tag size="mini" type="warning" effect="dark">{this.$LANG('1970', '已发起')}</el-tag>
                                    return <span>{value}</span>
                                }
                                if (item.key === 'ISCHK') return value === 'Y' ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> : value === 'N' ? <el-tag size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> : <span>{value}</span>
                                if (item.key === 'SEL') return <el-checkbox true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                if (item.key === 'IMGPATH') {
                                    const isPdf =value && String(value).toLowerCase().lastIndexOf('.pdf') > -1
                                    return <el-link underline={false}>
                                        {isPdf
                                            ? <div on-click={() => this.imgPreview(value)}><i class="iconfont icon-pdf"></i></div>
                                            : <el-image style="width:100%;height:20px" src={value} preview-src-list={[value]}><div slot="error"><i class="el-icon-picture-outline"></i></div></el-image>}
                                    </el-link>
                                }
                                return <div style="float:left">{value}</div>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        renderHeaderCell: (params, h) => <el-link underline={false} on-click={() => this.rowShow()} style="font-size:12px;color:#404eff"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link>,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 130,
                        align: 'center',
                        fixed: 'right',
                        renderBodyCell: ({row, rowIndex}, h) => (
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                {row.ISCHK !== 'Y' ? <span><i class="iconfont icon-chenggong" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={row.STFG !== 'Y'} on-click={() => this.editRec(row, 'C', rowIndex)} underline={false}><span style="font-size:12px;margin-right:3px">{this.$LANG('0364', '确认')}</span></el-link></span> : <span><i class="iconfont icon-chucuo" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={row.STFG !== 'Y'} on-click={() => this.stfgRec(row, rowIndex)} underline={false}><span style="font-size:12px;margin-right:3px">{this.$LANG('0314', '弃认')}</span></el-link></span>}
                            </div>
                        ),
                    })
                    vm.getSetList()
                })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397191','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.perCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397191','lstseq','4','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            }
        }
    }
    delete page._Ctor
    delete page.render
    delete page.staticRenderFns
    delete page._scopeId
    return page
}

const options = createOrderOptions(OrderPage)
options.components = { ...options.components, EasyWin }
export default options
</script>
<style scoped lang="less">
    .suppo-ord-page {
        background: white;
    }
    .suppo-ord-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-width: 1000px;
        height: 40px !important;
        min-height: 40px !important;
        padding: 4px 8px !important;
        background: #fff;
        line-height: normal;
        border-bottom: 1px solid #e2e8f0;
        box-sizing: border-box;
    }
    .toolbar-left-group, .toolbar-right-group {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;

        /deep/ .el-button {
            height: 30px !important;
            line-height: 30px !important;
            padding: 0 12px !important;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
        }
        /deep/ .el-button [class*="icon-"] {
            font-size: 13px;
            margin-right: 4px;
        }
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }

 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .active {
        color:#D200D2;
    }
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>

<style scoped src="./fieldSettings.css"></style>
